module.exports = __webpack_public_path__ + "media/bootstrap-icons/hdd-network-fill-b69327be.svg";